<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="3" md="3">
        <v-card>
          <v-card-subtitle>Ingrese Numero de Guia Master</v-card-subtitle>
          <v-card-text>
            <v-text-field label="Guia Master" v-model="guiaMaster" clearable prepend-icon="mdi-earth" @keyup.enter="fillCompras()"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="indigo" dark @click="fillCompras()">Buscar <v-icon>mdi-card-search</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="9" md="9">
        <v-card>
          <v-toolbar dense>
            <v-toolbar-title>Guias Relacionadas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-divider vertical></v-divider>
            <v-btn color="red" dark @click="eliminarGuias()">Eliminar <v-icon>mdi-delete-forever</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="compras"
            class="elevation-1"
            :single-select="false"
            show-select
            item-key="guia_hija"
            v-model="selected"
          >
          </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import apicon from '../plugins/apicon';
export default {
  data(){
    return{
      compras: [],
        headers: [
          { text: "Cliente", value: "cliente" },
          { text: "Guia Master", value: "guia_master" },
          { text: "Guia Hija", value: "guia_hija" },
          { text: "Vuelo", value: "no_vuelo" },
          { text: "Shipper", value: "shipper" },
          { text: "Destinatario", value: "destinatario" },
          { text: "Ciudad", value: "ciudad" },
          { text: "Remitente", value: "remitente" },
          { text: "Pais Origen", value: "pais_origen" },
          { text: "Ciudad Origen", value: "ciudad_origen" },
          { text: "Estatus", value: "estatus.descripcion" },
        ],
        guiaMaster: null,
        selected: [],
    }
  },
  methods: {
    fillCompras:async function () {
        await apicon
          .getDataApi(
            apicon.getApiBaseUrl() +
              "buscarguiasclporcriterio?guia_master=" + this.guiaMaster
          )
          .then((result) => {
            this.compras = result;
          });
      },
      eliminarGuias: async function(){
        let dswalEliminar = {
          title: 'Alerta',
          text: 'Desea eliminar las guias seleccionadas?',
          icon: 'warning',
          showCancelButton: true
        }
        var self = this;
        this.$swal(dswalEliminar).then((resultdlg) => {
          if (resultdlg.value) {
            self.selected.forEach(async guia => {
              await apicon.deleteDataApi(apicon.getApiBaseUrl() + 'compraslinea/' + guia.id).then((result) => {
                console.log(result);
              })
            })
          }
          self.$swal("Finalizado")
          this.compras = [];
          this.selected = [];
          this.guiaMaster = null;
        });
      }
  }
}
</script>

<style>

</style>
